import React, { useState } from 'react';
import { Container, Row, Col, Card, Spinner, Image } from 'react-bootstrap';

import Step1Client from './components/Step1Client';
import Step2Service from './components/Step2Service';
import Step3Signature from './components/Step3Signature';
import Confirmation from './components/Confirmation';
import CheckoutFlow from './components/CheckoutFlow';

const INITIAL_FORM_DATA = {
  client: {},
  service: {},
  signature: {},
};

function App() {
  const params = new URLSearchParams(window.location.search);
  const isSimplifiedCheckout =
    params.has('appSku') ||
    params.has('app') ||
    params.has('applicationSku') ||
    params.has('application') ||
    params.has('app_sku') ||
    params.has('planSku') ||
    params.has('plan') ||
    params.has('planId') ||
    params.has('plan_sku');

  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [submitting, setSubmitting] = useState(false);

  const handleNext = () => setStep(prev => prev + 1);
  const handleBack = () => setStep(prev => prev - 1);

  const updateClientData = (data) => setFormData(prev => ({ ...prev, client: data }));
  const updateServiceData = (data) => setFormData(prev => ({ ...prev, service: data }));
  const updateSignatureData = (data) => setFormData(prev => ({ ...prev, signature: data }));
  const handleNewQuote = () => {
    setSubmitting(false);
    setFormData(INITIAL_FORM_DATA);
    setStep(1);
  };

  const handleSubmit = async () => {
    setSubmitting(true);

    const payload = {
      fecha_solicitud: new Date().toISOString(),
      cliente: {
        ruc: formData.client.ruc,
        dv: formData.client.dv,
        nombre_razon_social: formData.client.name,
        tipo_contribuyente: formData.client.type,
        correo: formData.client.email,
        telefono: formData.client.phone || null,
        nombre_contacto: formData.client.contactPerson || null,
      },
      servicio_contratado: {
        aplicacion: {
          nombre: formData.service.application,
          sku: formData.service.applicationSku,
          descripcion_otro: formData.service.otherDescription || null,
        },
        plan_suscripcion: {
          sku: formData.service.plan?.id, // Using id as placeholder for SKU
          folios_anuales: formData.service.plan?.folios,
          nombre_amigable: formData.service.plan?.friendlyName,
        }
      },
      incluir_gestion_firma_electronica: formData.signature.includeSignatureService,
    };

    try {
      console.log('Payload enviado a cotización:', payload);
      const response = await fetch('https://hub.efacturapty.com/estimate/create', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorText = await response.text().catch(() => '');
        throw new Error(`Solicitud fallida (${response.status}): ${errorText}`);
      }

      setSubmitting(false);
      setStep('confirmation');

    } catch (error) {
      console.error('Hubo un error al enviar la solicitud:', error);
      setSubmitting(false);
      alert('Ocurrió un error al enviar la solicitud. Por favor, intente de nuevo.');
    }
  };

  const darkLogoPath = `${process.env.PUBLIC_URL}/logo-h-letra-blanco.png`;
  const lightLogoPath = `${process.env.PUBLIC_URL}/${encodeURIComponent('logo-h 250x93.png')}`;
  const isDarkHeaderBackground = true;
  const headerLogo = isDarkHeaderBackground ? darkLogoPath : lightLogoPath;

  const renderStep = () => {
    switch (step) {
      case 1:
        return <Step1Client onNext={handleNext} data={formData.client} updateFormData={updateClientData} />;
      case 2:
        return <Step2Service onNext={handleNext} onBack={handleBack} data={formData.service} updateFormData={updateServiceData} />;
      case 3:
        return <Step3Signature onSubmit={handleSubmit} onBack={handleBack} data={formData.signature} updateFormData={updateSignatureData} />;
      case 'confirmation':
        return <Confirmation data={formData} onNewQuote={handleNewQuote} />;
      default:
        return null;
    }
  };

  return (
    <div className="wizard-page">
      <Container className="wizard-container">
        <Row className="justify-content-center">
          <Col md={8}>
            <Card className="wizard-card">
              <Card.Header as="div" className="wizard-card-header">
                <div className="wizard-header-content">
                  <h2 className="wizard-title">{isSimplifiedCheckout ? 'Suscripciones efacturapty' : 'Solicitar cotización'}</h2>
                  <Image src={headerLogo} alt="Logo Hezt" className="wizard-logo" />
                </div>
              </Card.Header>
              <Card.Body className="wizard-card-body">
                {isSimplifiedCheckout ? (
                  <CheckoutFlow />
                ) : (
                  <>
                    {step !== 'confirmation' && (
                      <div className="wizard-step-indicator">Paso {step} de 3</div>
                    )}
                    {submitting ? (
                      <div className="d-flex flex-column justify-content-center align-items-center h-100">
                        <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
                        <p className="mt-3">Enviando solicitud...</p>
                      </div>
                    ) : (
                      renderStep()
                    )}
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default App;
